/**
 * Custom Product Add-ons JavaScript
 * Robust Version - Handles quotes in titles correctly
 */

const CustomAddons = {
    state: {
        selectedVariants: {}, // groupKey: variantId
        groups: [],
        basePricecents: 0,
        moneyFormat: '${{amount}}'
    },

    init: function (groups) {
        if (!groups || groups.length === 0) return;

        console.log('Initializing Robust Add-ons:', groups);
        this.state.groups = groups;

        this.initMoneyFormat();
        this.renderAllGroups();
        this.bindGlobalEvents();
        this.updatePriceDisplay();
    },

    initMoneyFormat: function () {
        const sectionDataEl = document.querySelector('[data-section-type="static-product"][data-section-data]');
        if (sectionDataEl) {
            try {
                const data = JSON.parse(sectionDataEl.innerHTML);
                if (data.settings && data.settings.money_format) {
                    this.state.moneyFormat = data.settings.money_format;
                }
            } catch (e) {
                console.warn('Could not parse money format, using default');
            }
        }
    },

    renderAllGroups: function () {
        this.state.groups.forEach(group => {
            this.renderGroup(group);
        });
    },

    renderGroup: function (group) {
        const listId = `custom-addons-list-${group.key}`;
        const containerId = `group-container-${group.key}`;
        const container = document.getElementById(listId);
        const parentContainer = document.getElementById(containerId);

        if (!container) return;

        let optionsHtml = '';
        group.products.forEach(addon => {
            const isOos = !addon.available;
            const oosClass = isOos ? 'is-oos' : '';
            const priceHtml = isOos ? '<span class="custom-addons-option-oos">Out of Stock</span>' : `<span class="custom-addons-option-price">+ ${addon.price}</span>`;

            // We only put the ID in the data attribute to avoid quote issues with titles
            optionsHtml += `
                <div class="custom-addons-option ${oosClass}" data-variant-id="${addon.variantId}" data-group-key="${group.key}">
                    <img src="${addon.image}" alt="${addon.title}" class="custom-addons-option-image">
                    <div class="custom-addons-option-info">
                        <span class="custom-addons-option-name">${addon.title}</span>
                        ${priceHtml}
                    </div>
                </div>
            `;
        });

        if (optionsHtml !== '') {
            container.innerHTML = `
                <div class="custom-addons-dropdown-wrapper" data-group-key="${group.key}">
                    <div class="custom-addons-select-trigger" data-placeholder="${group.placeholder}">${group.placeholder}</div>
                    <div class="custom-addons-options-list">
                        ${optionsHtml}
                    </div>
                </div>
            `;
            parentContainer.style.display = 'block';
            this.bindGroupEvents(group.key);
        }
    },

    bindGroupEvents: function (groupKey) {
        const wrapper = document.querySelector(`.custom-addons-dropdown-wrapper[data-group-key="${groupKey}"]`);
        const trigger = wrapper.querySelector('.custom-addons-select-trigger');
        const options = wrapper.querySelectorAll('.custom-addons-option');

        // Toggle dropdown
        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            document.querySelectorAll('.custom-addons-dropdown-wrapper').forEach(other => {
                if (other !== wrapper) other.classList.remove('is-open');
            });
            wrapper.classList.toggle('is-open');
        });

        // Option selection
        options.forEach(option => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();

                if (option.classList.contains('is-oos')) return;

                const variantId = option.dataset.variantId;

                // Lookup the product data from our internal state instead of the HTML
                let selectedAddon = null;
                const group = this.state.groups.find(g => g.key === groupKey);
                if (group) {
                    selectedAddon = group.products.find(p => p.variantId === variantId);
                }

                if (selectedAddon) {
                    this.state.selectedVariants[groupKey] = variantId;

                    // Update UI state in the list
                    options.forEach(opt => opt.classList.remove('is-selected'));
                    option.classList.add('is-selected');

                    trigger.innerHTML = `
                        <img src="${selectedAddon.image}" class="custom-addon-selected-image">
                        <span class="custom-addon-selected-name">${selectedAddon.title}</span>
                        <span class="custom-addon-selected-price">${selectedAddon.price}</span>
                        <span class="custom-addon-clear" onclick="CustomAddons.clearSelection(event, '${groupKey}')">&times;</span>
                    `;
                    trigger.classList.add('has-selection');
                    this.updatePriceDisplay();
                }

                wrapper.classList.remove('is-open');
            });
        });
    },

    clearSelection: function (event, groupKey) {
        if (event) event.stopPropagation();

        const wrapper = document.querySelector(`.custom-addons-dropdown-wrapper[data-group-key="${groupKey}"]`);
        const trigger = wrapper.querySelector('.custom-addons-select-trigger');
        const options = wrapper.querySelectorAll('.custom-addons-option');

        delete this.state.selectedVariants[groupKey];

        // Reset list state
        options.forEach(opt => opt.classList.remove('is-selected'));

        trigger.innerHTML = trigger.dataset.placeholder;
        trigger.classList.remove('has-selection');
        this.updatePriceDisplay();
    },

    updatePriceDisplay: function () {
        const sectionDataEl = document.querySelector('[data-section-type="static-product"][data-section-data]');
        if (!sectionDataEl) return;

        try {
            const data = JSON.parse(sectionDataEl.innerHTML);
            const sectionId = sectionDataEl.getAttribute('data-section-id');
            const sectionEl = document.querySelector(`[data-section="${sectionId}"]`) || document.body;

            const mainForm = sectionEl.querySelector('form[action="/cart/add"]');
            const currentVariantId = mainForm?.querySelector('input[name="id"]')?.value;

            const variant = data.product.variants.find(v => v.id.toString() === currentVariantId);
            let totalPrice = variant ? variant.price : data.product.price;

            // Add selected add-ons
            Object.keys(this.state.selectedVariants).forEach(groupKey => {
                const variantId = this.state.selectedVariants[groupKey];
                const group = this.state.groups.find(g => g.key === groupKey);
                if (group) {
                    const addon = group.products.find(p => p.variantId === variantId);
                    if (addon && addon.priceCents) {
                        totalPrice += addon.priceCents;
                    }
                }
            });

            // Update all price elements
            const formattedPrice = this.formatMoney(totalPrice, this.state.moneyFormat);
            const isOnSale = sectionEl.querySelector('.price--on-sale');

            if (isOnSale) {
                // Update only the sale price items
                sectionEl.querySelectorAll('.price-item--sale').forEach(el => {
                    el.innerText = formattedPrice;
                });
            } else {
                // Update the regular price items (in the regular container)
                sectionEl.querySelectorAll('.price__regular .price-item--regular').forEach(el => {
                    el.innerText = formattedPrice;
                });
            }

            // Also update the user's custom price structure if it exists
            sectionEl.querySelectorAll('.product-price .price').forEach(el => {
                el.innerText = formattedPrice;
            });

            // Update Affirm "As Low As" price messaging
            this.updateAffirm(totalPrice, sectionEl);

        } catch (e) {
            console.error('Error updating price display:', e);
        }
    },

    updateAffirm: function (totalCents, sectionEl) {
        // Find any Affirm "as low as" elements
        const affirmElements = sectionEl.querySelectorAll('.affirm-as-low-as');
        if (affirmElements.length > 0) {
            affirmElements.forEach(el => {
                // Update the data-amount attribute (Affirm expects cents)
                el.setAttribute('data-amount', totalCents);
            });

            // Trigger Affirm UI refresh if the script is loaded
            if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
                window.affirm.ui.refresh();
            }
        }
    },

    formatMoney: function (cents, format) {
        if (typeof cents === 'string') cents = cents.replace('.', '');
        let value = '';
        let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = precision || 2;
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number == null) return 0;

            number = (number / 100.0).toFixed(precision);

            let parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? decimal + parts[1] : '';

            return dollars + cents;
        }

        switch (format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return format.replace(placeholderRegex, value);
    },

    bindGlobalEvents: function () {
        document.addEventListener('click', () => {
            document.querySelectorAll('.custom-addons-dropdown-wrapper').forEach(w => w.classList.remove('is-open'));
        });

        const mainForm = document.querySelector('form[action="/cart/add"]');
        if (mainForm) {
            mainForm.addEventListener('change', () => {
                // Small delay to allow theme JS to update the variant ID input
                setTimeout(() => this.updatePriceDisplay(), 50);
            });

            const atcButton = mainForm.querySelector('button[type="submit"]');
            if (atcButton) {
                atcButton.addEventListener('click', async (e) => {
                    const selectedIds = Object.values(this.state.selectedVariants);
                    if (selectedIds.length > 0) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        await this.addToCartWithAddons(selectedIds);
                    }
                }, true);
            }
        }
    },

    addToCartWithAddons: async function (selectedIds) {
        const mainForm = document.querySelector('form[action="/cart/add"]');
        if (!mainForm) return;

        const mainVariantInput = mainForm.querySelector('input[name="id"]');
        if (!mainVariantInput) return;

        const items = [{
            id: mainVariantInput.value,
            quantity: 1
        }];

        selectedIds.forEach(variantId => {
            items.push({ id: variantId, quantity: 1 });
        });

        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items })
            });

            if (response.ok) {
                window.location.href = '/cart';
            } else {
                const error = await response.json();
                alert('Error: ' + (error.description || error.message));
            }
        } catch (error) {
            console.error('Cart error:', error);
        }
    }
};

window.CustomAddons = CustomAddons;
